import React from 'react';
import { Zap, AlertTriangle } from 'lucide-react';

export default function SpikeDaysCard() {
  return (
    <div
      className="rounded-[5px] p-5 hover:shadow-[rgba(150,25,50,0.12)_0px_10px_30px] transition-all duration-200 hover:-translate-y-0.5 border"
      style={{
        backgroundColor: 'rgba(150, 25, 50, 0.07)',
        borderColor: 'rgba(150, 25, 50, 0.2)',
      }}
    >
      <div className="flex items-start justify-between mb-4">
        <div>
          <p className="text-xs font-500 uppercase tracking-wide text-[#961932] mb-1">
            Spike Days
          </p>
          <p className="text-3xl font-700 tabular-nums text-[#39364E]">
            7
          </p>
          <p className="text-xs text-[#961932] mt-1">Last 30 days</p>
        </div>
        {/* Smarty crimson icon wrapper */}
        <div
          className="w-[50px] h-[50px] rounded-[5px] flex items-center justify-center"
          style={{ backgroundColor: 'rgb(140, 11, 49)' }}
        >
          <Zap size={22} className="text-white" />
        </div>
      </div>
      <div className="flex items-center gap-1.5">
        <AlertTriangle size={12} className="text-[#961932]" />
        <span className="text-[11px] font-500 text-[#961932]">
          3 spikes above 40% threshold
        </span>
      </div>
      <p className="text-[11px] text-[#8C0B31] mt-2">
        Highest: <span className="font-600 tabular-nums">+83%</span> on Mar 28
      </p>
    </div>
  );
}